import axios from 'axios';
import { API_URL } from '../config/api.config';

const getAuthInfo = () => {
  const garageId = JSON.parse(localStorage.getItem('user') || '{}')._id || ''
  const token = localStorage.getItem('token');
  return { garageId, token };
};
const createAuthAxios = () => {
  const { token } = getAuthInfo();
  return axios.create({
    baseURL: API_URL,
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};
const authAxios = createAuthAxios()

export const quoteService = {
  async createQuote(quoteData: any) {
    try {
      const response = await authAxios.post(`/quotes/`, quoteData);
      console.log(response.data._id);
     // await this.updateQuoteStatus(response.data._id, 'sent');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getQuotesByGarage(garageId: string) {
    try {
      const response = await authAxios.get(`/quotes/garage/${garageId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getQuoteByInspection(inspectionId: string) {
    try {
      const response = await authAxios.get(`/inspection/${inspectionId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getQuoteDetails(quoteId: any) {
     try {
       const response = await authAxios.get(`/quotes/${quoteId}`);
       console.log("details quotes" ,response);
       return response.data;
     }
     catch (error) {
       throw error;
     }
  },
  async updateQuoteStatus(quoteId: any, newStatus: String) {
    try {
      const response = await authAxios.put(`/quotes/${quoteId}/status`, { status: newStatus });

      console.log("updateQuoteStatus details quotes" ,response);
      return response.data;
    }
    catch (error) {
      throw error;
    }
  },


  async downloadQuotePDF(quoteId: any) {
    try {
      // Faites une requête GET vers l'API avec responseType blob pour récupérer le PDF
      const response = await authAxios.get(`/quotes/${quoteId}/download`, {
        responseType: 'blob'
      });

      // Créer une URL blob à partir de la réponse
      const blob = new Blob([response.data], { type: 'application/pdf' });

      // Utiliser URL (pas window.URL) pour éviter les erreurs TypeScript
      const url = URL.createObjectURL(blob);

      // Créer un lien temporaire et déclencher le téléchargement
      const link = document.createElement('a');
      link.href = url;

      // Extraire le nom du fichier de l'en-tête Content-Disposition s'il existe
      let filename = `devis_${quoteId}.pdf`;
      const contentDisposition = response.headers['content-disposition'];
      if (contentDisposition && contentDisposition.includes('filename=')) {
        const filenameMatch = contentDisposition.match(/filename=["']?([^"']+)["']?/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }

      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

      // Nettoyer
      URL.revokeObjectURL(url);
      document.body.removeChild(link);

      return true;
    } catch (error) {
      console.error('Erreur lors du téléchargement du PDF:', error);
      return false;
    }
  }
};